import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ShowVendorEvent } from "../../../../context/Slice/EventManagementSlice";
import { createEventInCalender } from "../../../../context/Slice/CalenderSlice";
import "./VendorEvents.css";
import secureLocalStorage from "react-secure-storage";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router";
import moment from "moment";
import { Button } from "@mui/material";
import axios from "axios";
const BASE_URL = process.env.REACT_APP_BASE_URL;


const VendorEvents = () => {
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const allEvents = useSelector((state) => state.EventManagementR.Data);
  const [show, setShow] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [ID, setID] = useState("");

  const [formData, setFormData] = useState({
    Title: "",
    Description: "",
    serviceName: "",
    Proposed_Date: "",
    Start_Date: "",
    End_Date: "",
  });
  const token = secureLocalStorage.getItem("token");

  console.log("allEvents", allEvents);

  useEffect(() => {
    if (token) {
      try {
        const decoded = jwtDecode(token);
        const ID = decoded._id;
        setID(ID);
        dispatch(ShowVendorEvent(ID));
      } catch (error) {
        console.error("Token decoding failed:", error);
      }
    }
  }, [dispatch, token]);

  const handleClose = () => setShow(false);
  const handleShow = (event) => {
    setSelectedEvent(event);
    setShow(true);
  };

  const handleAdd = (event) => {
    setSelectedEvent(event);
    setFormData({
      Title: event.Event_Name,
      Description: "",
      serviceName: event.serviceName,
      Proposed_Date: event.Proposed_Date,
      Start_Date: event.Start_date,
      End_Date: event.End_date,
      Vendor_ID: event.vendor_id,
      Coordinator_ID: event.coordinator_id,
    });
    setShowAddModal(true);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
  
    try {
      // Format dates using Moment.js
      const formatDate = (date) => (date ? moment(date).format("YYYY-MM-DD") : "");
  
      // const formattedProposedDate = formatDate(formData.Proposed_Date);
      const formattedStartDate = formatDate(formData.Start_Date);
      const formattedEndDate = formatDate(formData.End_Date);
  
      // Prepare event data
      const EventData = {
        vendor_id: ID,
        // coordinator_id: ID,
        Type: "inCalender",
        Title: formData.Title,
        Description: formData.Description,
        Whole_day: formData.allDay,
        Start_Date: formattedStartDate,
        End_Date: formattedEndDate,
      };
  
      console.log("Submitting Event Data:", EventData);
  
      // API Call using axios
      const response = await axios.post(
        `${BASE_URL}/api/v1/VendorCalenders/createVendor-InCalender`,
        EventData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
  
      // Handle success response
      if (response.status === 201) {
        alert("Event added successfully!");
      } else {
        alert("Failed to add event. Please try again.");
      }
    } catch (error) {
      console.error("Error submitting event:", error);
      alert("An error occurred while adding the event.");
    }
  };
  

  const filteredEvents = allEvents.ShowVendorEvent
    ? allEvents.ShowVendorEvent.filter((event) => {
        const eventNameMatch =
          event.Event_Name &&
          event.Event_Name.toLowerCase().includes(searchTerm.toLowerCase());
        const userNameMatch =
          event.User &&
          (event.User.firstName + " " + event.User.lastName)
            .toLowerCase()
            .includes(searchTerm.toLowerCase());
        return eventNameMatch || userNameMatch;
      })
    : [];

    const HandleBack = () => {
      console.log("Back button clicked");
      navigate('/vendor-dashboard');
    };

  return (
    <div id="VendorEvents">
      {/* Back Button */}
            <Button
              variant="contained"
              color="secondary"
              onClick={HandleBack}
              sx={{ position: "absolute", top: "20px", left: "20px" }}
            >
              Back
            </Button>
      <div>
        <h2 className="heading">Events</h2>
        <div className="searchField">
          <input
            type="text"
            placeholder="Search by Name or Event Name"
            className="searchInput"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      </div>
      <div className="grid">
        {filteredEvents && filteredEvents.length > 0 ? (
          filteredEvents.map((event, index) => (
            <div className="card" key={index}>
              <div className="card-body">
                <h5 className="card-title fw-bold">{event.Event_Name}</h5>
                <p className="card-text">
                  <strong>Service Name:</strong> {event.serviceName}
                </p>
                <p className="card-text">
                  <strong>Guest :</strong> {event.Guest}
                </p>
                <p className="card-text">
                  <strong>Start Date:</strong>{" "}
                  {moment(event.Start_date).format("DD/MM/YYYY")}
                </p>
                <p className="card-text">
                  <strong>End Date:</strong>{" "}
                  {moment(event.End_date).format("DD/MM/YYYY")}
                </p>
                <p className="card-text">
                  <strong>Proposed Date:</strong>{" "}
                  {moment(event.Proposed_Date).format("DD/MM/YYYY")}
                </p>
                <button className="btn mb-3" onClick={() => handleShow(event)}>
                  View
                </button>
                <button className="btn" onClick={() => handleAdd(event)}>
                  Add Event
                </button>
              </div>
            </div>
          ))
        ) : (
          <p>No events available.</p>
        )}
      </div>

      {show && selectedEvent && (
        <div className="custom-modal">
          <div className="custom-modal-content">
            <div className="custom-modal-header">
              <h5 className="custom-modal-title">{selectedEvent.Event_Name}</h5>
            </div>
            <div className="custom-modal-body">
              <p className="card-text">
                <strong>Service Name:</strong> {selectedEvent.serviceName}
              </p>
              <p className="card-text">
                <strong>Guest :</strong> {selectedEvent.Guest}
              </p>
              <p className="card-text">
                <strong>Start Date:</strong>{" "}
                {moment(selectedEvent.Start_date).format("DD/MM/YYYY")}
              </p>
              <p className="card-text">
                <strong>End Date:</strong>{" "}
                {moment(selectedEvent.End_date).format("DD/MM/YYYY")}
              </p>
              <p className="card-text">
                <strong>Proposed Date:</strong>{" "}
                {moment(selectedEvent.Proposed_Date).format("DD/MM/YYYY")}
              </p>
            </div>
            {selectedEvent.Coordinator && (
              <>
                <div className="custom-modal-header">
                  <h5 className="custom-modal-title">
                    Event Co-Ordinator Details
                  </h5>
                </div>
                <div className="custom-modal-body">
                  <p className="card-text">
                    <strong>Name:</strong> {selectedEvent.Coordinator.firstName}{" "}
                    {selectedEvent.Coordinator.lastName}
                  </p>
                  <p className="card-text">
                    <strong>Email:</strong> {selectedEvent.Coordinator.email}
                  </p>
                  <p className="card-text">
                    <strong>Mobile No:</strong>{" "}
                    {selectedEvent.Coordinator.mobile_number}
                  </p>
                </div>
              </>
            )}
            <div className="custom-modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={handleClose}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {showAddModal && (
        <div className="custom-modal">
          <div className="custom-modal-content">
            <div className="custom-modal-header">
              <h5 className="custom-modal-title">Add Event</h5>
            </div>
            <div className="custom-modal-body">
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label>Title</label>
                  <input
                    type="text"
                    className="form-control"
                    name="Title"
                    value={formData.Title}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="form-group">
                  <label>Description</label>
                  <textarea
                    className="form-control"
                    name="Description"
                    value={formData.Description}
                    onChange={handleInputChange}
                  ></textarea>
                </div>
                <div className="form-group">
                  <label>Service Name</label>
                  <input
                    type="text"
                    className="form-control"
                    name="serviceName"
                    value={formData.serviceName}
                    onChange={handleInputChange}
                  />
                </div>
                {/* <div className="form-group">
                  <label>Proposed Date</label>
                  <input
                    type="date"
                    className="form-control"
                    name="Proposed_Date"
                    value={formData.Proposed_Date}
                    onChange={handleInputChange}
                  />
                </div> */}
                <div className="form-group">
                  <label>Start Date</label>
                  <input
                    type="date"
                    className="form-control"
                    name="Start_Date"
                    value={formData.Start_Date}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="form-group">
                  <label>End Date</label>
                  <input
                    type="date"
                    className="form-control"
                    name="End_Date"
                    value={formData.End_Date}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="custom-modal-footer">
                  <button type="submit" className="btn btn-primary">
                    Add Event in Calendar
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => setShowAddModal(false)}
                  >
                    Close
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default VendorEvents;
